import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import api from '../lib/api';
import { EyeOpen, EyeOff } from '../components/icons';

export default function Register() {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [facility, setFacility] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!firstName || !lastName || !email || !password || !facility) return toast.error('Fill all fields');
    try {
      setLoading(true);
      const { data } = await api.post('/auth/register', { firstName, lastName, email, password, facility });
      if (data?.token) {
        localStorage.setItem('auth_token', data.token);
        if (data.refreshToken) localStorage.setItem('refresh_token', data.refreshToken);
        toast.success('Account created');
        navigate('/account');
      } else {
        toast.error('Registration failed');
      }
    } catch (err: any) {
      toast.error(err?.response?.data?.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-custom pt-28 sm:pt-32 pb-16">
      <div className="max-w-md mx-auto card">
        <h1 className="text-2xl font-semibold mb-6">Create your account</h1>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm mb-1">First name</label>
              <input
                className="input-field"
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="block text-sm mb-1">Last name</label>
              <input
                className="input-field"
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                required
              />
            </div>
          </div>
          <div>
            <label className="block text-sm mb-1">Facility name</label>
            <input
              className="input-field"
              placeholder="Clinic, Hospital or Company"
              value={facility}
              onChange={(e) => setFacility(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="block text-sm mb-1">Email</label>
            <input type="email" className="input-field" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </div>
          <div>
            <label className="block text-sm mb-1">Password</label>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                className="input-field pr-12"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword((v) => !v)}
                className="absolute inset-y-0 right-2 my-auto h-9 w-9 rounded-xl text-gray-600 hover:text-[#0D56A6] hover:bg-gray-100 transition-colors flex items-center justify-center"
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? <EyeOff size={18} /> : <EyeOpen size={18} />}
              </button>
            </div>
          </div>
          <button type="submit" className="w-full bg-[#0D56A6] hover:bg-[#0A4A8F] text-white font-semibold py-3 px-4 rounded-2xl transition-colors" disabled={loading}>
            {loading ? 'Creating account…' : 'Create account'}
          </button>
        </form>
        <p className="text-sm text-gray-600 mt-4">
          Already have an account? <Link to="/login" className="text-[#0D56A6] hover:underline">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
